import React from "react";
import { Input, Label } from "reactstrap";

interface SearchBarProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ label = "Search", value, onChange, placeholder }) => (
  <div className="dataTables_filter d-flex align-items-center search-container">
    <Label className="me-2">{label}:</Label>
    <Input
      type="search"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </div>
);

export default SearchBar;